import { WorkerSearchHero } from './content/worker-search-hero'

// Canonical front-door per business_model_and_pricing_sot.md §2:
// "Poly is a digital workforce marketplace. Customers hire digital employees,
//  teams, or departments to execute business functions."
// The search hero is the literal expression of that — browse the workforce,
// filter by category, deploy. Replaces the previous "DIGITAL INFRASTRUCTURE"
// headline which used the messaging-standards "avoid" word "infrastructure".
export function Home() {
  return <WorkerSearchHero />
}
